import { memo } from 'react'

import { BrokenImageOutlined, VideocamOffOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'

import { NoSrcPlaceholderWrapper, Thumbnail } from 'domains/Workspaces/Events/layouts'

export type ThumbnailPreviewProps = {
  /** The server-resolved thumbnail from `event.status` — the ONLY source; no fallback. */
  resolvedThumbnailUrl?: string
}

/**
 * Read-only per-camera thumbnail, taken strictly from the event status
 * `resolvedThumbnail`. Anything that isn't a loadable https url (e.g. an
 * internal `nw://` url the backend hasn't resolved yet) renders the placeholder
 * — there is deliberately no stream/other fallback. Reuses the list rendering.
 */
const ThumbnailPreviewRaw = ({ resolvedThumbnailUrl }: ThumbnailPreviewProps) => {
  const src = resolvedThumbnailUrl && /^https?:\/\//i.test(resolvedThumbnailUrl) ? resolvedThumbnailUrl : undefined

  return (
    <Box sx={{ flexShrink: 0 }}>
      {src ? (
        <picture>
          <Thumbnail type="image/jpeg" data={src}>
            <NoSrcPlaceholderWrapper>
              <BrokenImageOutlined />
            </NoSrcPlaceholderWrapper>
          </Thumbnail>
        </picture>
      ) : (
        <NoSrcPlaceholderWrapper>
          <VideocamOffOutlined />
        </NoSrcPlaceholderWrapper>
      )}
    </Box>
  )
}

export const ThumbnailPreview = memo(ThumbnailPreviewRaw)
